<div class="form no-wrapper scroll-panel">
  <div class="my-6 mx-12 flex flex-col gap-4">
    <label class="text-grey">
      Active Scan detects devices, identifies open ports, and gathers detailed information about services, including the capability to determine the
      operating system and device type.
    </label>
    <div class="flex flex-col gap-4">
      <label class="font-bold"> Select where to initiate Active Scan from. </label>
      <div class="flex items-baseline gap-2">
        <p-radioButton name="scanType" [value]="SCAN_TYPES.IDS" [ngModel]="scanType()" (ngModelChange)="scanType.set(SCAN_TYPES.IDS)" />
        <div class="flex flex-col">
          <label>MicroIDS</label>
          <label class="text-grey">Initiate scan on devices, IP range or physical connection from MicroIDS.</label>
        </div>
      </div>
      <div class="flex items-baseline gap-2">
        <p-radioButton name="scanType" [value]="SCAN_TYPES.EDGE" [ngModel]="scanType()" (ngModelChange)="scanType.set(SCAN_TYPES.EDGE)" />
        <div class="flex flex-col">
          <label>MicroAgent</label>
          <label class="text-grey">Initiate scan on available connections from MicroAgent.</label>
        </div>
      </div>
    </div>
    @if (scanType() === SCAN_TYPES.EDGE) {
      <div>
        <microsec-card [isTableCard]="true">
          <microsec-common-table
            #dt
            [lazy]="true"
            (lazyLoadEvent)="getEdgeDevices(false, $any($event))"
            [totalRecords]="totalRecords"
            [cols]="cols"
            [values]="edgeDevices"
            selectionMode="multiple"
            [selectable]="true"
            selectableRowDisabledKey="disabled"
            [(selection)]="selectedEdgeDevices"
            [loading]="isLoading"
            [cellTemplate]="cellTemplate"
            [dataKey]="'id'"
            itemName="Device" />
        </microsec-card>
      </div>
    }
  </div>
</div>
<div class="my-4 mx-8">
  <div class="flex flex-row items-center justify-end gap-2">
    <p-button severity="secondary" type="button" (onClick)="onCancel()" label="Cancel" />
    <p-button
      type="button"
      severity="primary"
      [disabled]="scanType() === SCAN_TYPES.EDGE && !selectedEdgeDevices.length"
      icon="fa fa-angle-right"
      iconPos="right"
      label="Next"
      (onClick)="onNext()" />
  </div>
</div>

<ng-template let-col="col" let-rowData="rowData" #cellTemplate>
  <ng-container [ngSwitch]="col.field">
    <!-- Connection -->
    <ng-container *ngSwitchCase="'connections'">
      <div
        class="flex items-center w-max"
        [pTooltip]="!!rowData[col.field]?.length ? $any(rowData[col.field] | arrayMapPipe: 'name' : true) : ''"
        tooltipPosition="top"
        appendTo="body">
        <ng-container *ngFor="let connection of rowData[col.field] || []; let i = index; let firstConn = first; let lastConn = last">
          <label *ngIf="!!firstConn">
            {{ connection.name }}
          </label>
          <div *ngIf="!firstConn && !!lastConn" class="ml-1">...</div>
        </ng-container>
      </div>
    </ng-container>
    <!-- Type -->
    <ng-container *ngSwitchCase="'type'">
      <microsec-truncate-text>
        {{ (rowData[col.field] | constant: 'detected-device-type') || '-' }}
      </microsec-truncate-text>
    </ng-container>
    <!-- Zone -->
    <ng-container *ngSwitchCase="'zones'">
      <div
        class="flex items-center w-max"
        [pTooltip]="!!rowData[col.field]?.length ? $any(rowData[col.field] | arrayMapPipe: 'label' : true) : ''"
        tooltipPosition="top"
        appendTo="body">
        <ng-container *ngFor="let zone of rowData[col.field] || []; let i = index; let firstZone = first; let lastZone = last">
          <div *ngIf="!!firstZone" class="custom-chip" [style]="{ background: util.hexToRgba(zone.color), color: zone.color }">
            {{ zone.label }}
          </div>
          <div *ngIf="!firstZone && !!lastZone" class="ml-1">+{{ i }}</div>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <div class="overflow-hidden whitespace-nowrap text-ellipsis">
        {{ rowData[col.field] || '-' }}
      </div>
    </ng-container>
  </ng-container>
</ng-template>
